import { PeoplePicker } from './PeoplePicker';
export default PeoplePicker;
